import { createFileRoute } from "@tanstack/react-router";
import WhtToolPage from "@/features/public/pages/tools/wht";

export const Route = createFileRoute("/(public)/_public/tools/wht")({
  component: WhtToolPage,
});
